import React from "react";
import NoInternetPage from "../NoInternetPage";
import useNetworkStatus from "../useNetworkStatus";

const CheckConnection = ({ children }) => {
  const { isOnline } = useNetworkStatus();

  return isOnline ? children : <NoInternetPage />;
};

export default CheckConnection;
